import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from "@angular/common";
import 'rxjs/add/operator/switchMap';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'site-loginPage',
  templateUrl: './loginPage.component.html',
  styleUrls: ['./loginPage.component.css']
})
export class LoginPage
{

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/loginPage/loginPage.component.ts